import ImportScreen from "~/components/import/ImportScreen";
import { Permission } from "~/hooks/permissions";
import PermissionOrWarn from "~/components/common/PermissionOrWarn";

import {
  CREATE_USER_DATA_IMPORT,
  GET_USER_DATA_IMPORT,
  DELETE_USER_DATA_IMPORT,
  GET_USER_DATA_IMPORT_PREVIEW,
  EXECUTE_USER_DATA_IMPORT,
} from "~/components/import/graphqlQueries";

export default function TabImport() {
  return (
    <PermissionOrWarn permission={Permission.importUsers}>
      <ImportScreen 
        resourceType={"USER"}
        title={"Import Users and Providers"}
        gql={{
          createImport: CREATE_USER_DATA_IMPORT,
          deleteImport: DELETE_USER_DATA_IMPORT,
          executeImport: EXECUTE_USER_DATA_IMPORT,
          listImports: GET_USER_DATA_IMPORT,
          previewImport: GET_USER_DATA_IMPORT_PREVIEW,
        }}
        exampleColumnNamesAndTitles={[
          {name: "email", title: "Email"}, 
          {name: "firstName", title: "First name"}, 
          {name: "lastName", title: "Last name"},
          {name: "roles", title: "Roles"},
          {name: "active", title: "Active"},
          {name: "providerType", title: "Provider type"},
          {name: "serviceLines", title: "Service lines"},
          {name: "teams", title: "Teams"},
          {name: "gender", title: "Gender"},
          {name: "languages", title: "Languages"},
          {name: "licensedStates", title: "Licensed states"},
          {name: "addressStreet", title: "Address"},
          {name: "addressLineTwo", title: ""},
          {name: "addressCity", title: "City"},
          {name: "addressState", title: "State"},
          {name: "addressZip", title: "Zip"},
        ]}
        errorColumnNamesAndTitles={[
          {name: "email", title: "Email"}, 
          {name: "first_name", title: "First name"}, 
          {name: "last_name", title: "Last name"}
        ]}
      />
    </PermissionOrWarn>
  )
}
